import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUpload } from '@fortawesome/pro-solid-svg-icons';

import Attachment from './attachment';
import Attachments from 'bundles/backoffice/attachments';

import type { Attachment as AttachmentType, Task } from 'bundles/apex/tasks/types';

interface Props {
  attachmentsPath: string;
  canDeleteAttachments?: boolean;
  forUserId: number;
  task: Task;
  onAddAttachment: (task: Task, attachment: AttachmentType) => void;
  onDeleteAttachment: (task: Task, attachment: AttachmentType) => void;
}

export default function AttachmentsSection({
  attachmentsPath,
  canDeleteAttachments,
  forUserId,
  task,
  onAddAttachment,
  onDeleteAttachment,
}: Props) {
  const attachments = task.attachments || [];

  let dropzone;
  if (attachments.length > 0) {
    dropzone = (
      <div className="d-flex align-items-center task-sidebar-modal__attachment p-3 rounded">
        <div
          className={classNames(
            'attachment-icon',
            'attachment-icon-new',
            'border',
            'border-dashed',
            'rounded',
            'text-muted',
            'me-3',
          )}
        >
          <FontAwesomeIcon className="p-3" icon={faPlus} />
        </div>
        New Attachment
      </div>
    );
  } else {
    dropzone = (
      <div className="text-center uploader">
        <div className="text-muted mb-3">
          Drag and drop or click the button to upload files for this task
        </div>
        <div className="btn btn-ghost">
          <FontAwesomeIcon className="ms-2" icon={faUpload} size="lg" />
          Upload Files
        </div>
      </div>
    );
  }

  return (
    <div className="mt-3 mb-4 task-sidebar-modal__attachments">
      <Attachments
        attachable={{ id: task.id, type: 'Apex::Task' }}
        attachments={attachments}
        attachmentsPath={attachmentsPath}
        deleteEnabled={canDeleteAttachments}
        dropzone={dropzone}
        dropzoneOnly
        forUserId={forUserId}
        onAddAttachment={attachment => onAddAttachment(task, attachment)}
        onDeleteAttachment={attachment => onDeleteAttachment(task, attachment)}
      />
      {attachments.map(attachment => (
        <Attachment
          attachment={attachment}
          attachmentsPath={attachmentsPath}
          canDeleteAttachments={canDeleteAttachments}
          forUserId={forUserId}
          key={attachment.id}
          task={task}
          onDeleteAttachment={onDeleteAttachment}
        />
      ))}
    </div>
  );
}
